import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

import Color from '@tool/color';
import { GoLeftIcon, PhoneIcon3 } from '@/styled/icon';
import moOutput from '../store/output';
import { isEmpty, round } from 'lodash';
import defalut from '@static/image/default-bg.png';

interface IProps { }
interface IState { }

const OutputChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { outputTabActive, outputList } = moOutput;

  const [active, setActive] = useState(false);

  const changeShow = () => {
    setActive(!active);
  };

  const emen: any = {
    营业收入: 'revenue',
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
    薪酬成本: 'cost',
    净利润: 'profit',
  };


  const getTopList = useMemo(() => {
    const active = emen[outputTabActive];
    let cList: any = [];
    if (!isEmpty(outputList)) {
      cList = outputList[active]?.current_top10.map((item: any) => {
        let items: any = {};
        items = { ...item, icons: outputList.company_logo_dict[item.company_name] };
        return items;
      });
    }
    return cList;
  }, [outputList, outputTabActive]);

  const getMax = useMemo(() => {
    const active = emen[outputTabActive];
    let max: any = 0;
    if (!isEmpty(outputList)) {
      outputList[active]?.current_top10.forEach((item: any) => {
        if (item.value > max) {
          max = item.value;
        }
      });
    }
    return max;
  }, [outputList, outputTabActive]);

  const getDanwei = useMemo(() => {
    let type = 'big';
    if (outputTabActive === '营业收入' || outputTabActive === '薪酬成本' || outputTabActive === '净利润') {
      type = 'big';
    } else {
      type = 'samll';
    }
    return type;
  }, [outputTabActive]);

  useEffect(() => {
    return () => {
    };
  }, []);

  return (
    <section className="output-top10-warp">
      {
        getTopList?.map((res: any, r: any) => {
          return <section className='output-item' key={`${r}`}>
            <section className='show-bar'>
              <section className='show-number'>
                <i style={{
                  color: res.value >= 0 ? Color.secondary : Color.success,
                }}>
                  {getDanwei === 'big' ? round(res.value / 100000000, 2).toLocaleString() : round(res.value, 0).toLocaleString()}
                </i>
                {res.value >= 0 && <b style={{ height: `${Math.abs(res.value) * 100 / getMax}%` }} />}
                {res.value < 0 && <b style={{ height: `${Math.abs(res.value) * 100 / getMax}%` }} className="changeColor" />}
                {/* <p className='defalut'></p> */}
              </section>
              <section className='picwarps' style={{
                backgroundColor: res.value >= 0 ? Color.f76b : Color.c389,
              }}>
                <span style={{
                  backgroundImage: `url(${res.icons || defalut})`,
                }} />
              </section>
            </section>
            <span className='company'>{res.company_name}</span>
            <section className='show-rate'>
              <span style={{ color: res.ratio > 0 ? Color.error : Color.success }}>
                {round(res.ratio * 100, 1)}%
              </span>
              {res.ratio > 0 ? <span className='up'>
                <GoLeftIcon color={Color.red} />
              </span> :
                <span className='down'>
                  <GoLeftIcon color={Color.success} />
                </span>}
            </section>
          </section>;
        })
      }
    </section>
  );
};

export default observer(OutputChart);
